export default __webpack_public_path__ + "static/media/login-shapes.18c75cdb.svg";